'use client';

export function AmbientOrbs() {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      <div
        className="absolute w-[500px] h-[500px] rounded-full opacity-[0.06] animate-orb-drift-1"
        style={{
          background:
            'radial-gradient(circle, oklch(0.55 0.25 290), transparent 70%)',
          top: '10%',
          left: '15%',
        }}
      />
      <div
        className="absolute w-[400px] h-[400px] rounded-full opacity-[0.04] animate-orb-drift-2"
        style={{
          background:
            'radial-gradient(circle, oklch(0.75 0.15 195), transparent 70%)',
          bottom: '20%',
          right: '10%',
        }}
      />
    </div>
  );
}
